import { render, staticRenderFns } from "./ClientBillAttach.vue?vue&type=template&id=8b8eb5ec&"
import script from "./ClientBillAttach.js?vue&type=script&lang=js&"
export * from "./ClientBillAttach.js?vue&type=script&lang=js&"
import style0 from "./ClientBillAttach.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports